'use client';
import React, { useEffect, useState } from 'react';
import Script from 'next/script';

const Hotjar = () => {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined" && window.location.protocol === "https:") {
      setEnabled(true);
    }
  }, []);

  if (!enabled) return null;

  return (
    <Script id="hotjar-init" strategy="lazyOnload">
      {`
        (function(h,o,t,j,a,r){
          h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
          h._hjSettings={hjid:6475712,hjsv:6};
          a=o.getElementsByTagName('head')[0];
          r=o.createElement('script');r.async=1;
          r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
          a.appendChild(r);
        })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
      `}
    </Script>
  );
};

export default Hotjar;
